interface MoveProgressProps {
  messages: string[]
}

export function MoveProgress({ messages }: MoveProgressProps) {
  if (messages.length === 0) {
    return null
  }

  return (
    <div>
      <div className="text-xs font-semibold mb-1 text-muted">
        AI Progress:
      </div>
      <pre className="bg-secondary-bg text-secondary p-2 rounded text-xs overflow-x-auto">
        <code>
          {messages.map((msg, index) => (
            <div key={index} className="text-accent">
              {msg}
            </div>
          ))}
        </code>
      </pre>
    </div>
  )
}

